import React, { useEffect, useState } from "react";
import { RiTa } from "rita"
import Gliph from './Gliph';
import Rune from "./Rune";
import { Config } from "../App";

interface TunicIdeogram {
    transcript: string,
    config: Config
}

export interface PhonemPair {
    vowel: string,
    consonant: string,
    vowelfirst: boolean
}

function phones_to_group(word_phonem: Array<string>) {
    const vowel = ["a", "e", "i", "o", "u"]

    let binary_vowel = word_phonem.map(phonem => vowel.some(chr => phonem.at(0) == chr))
    let output: Array<PhonemPair> = []
    let current_group: PhonemPair = { vowel: "", consonant: "", vowelfirst: false }

    for (let index = 0; index < binary_vowel.length; index++) {
        const isVowel = binary_vowel[index];

        if (isVowel) {
            if (current_group.vowel != "") {
                output.push(current_group)
                current_group = { vowel: "", consonant: "", vowelfirst: false }
            }

            current_group.vowel = word_phonem.at(index) || ""
        }
        else {
            if (current_group.consonant != "") {
                output.push(current_group)
                current_group = { vowel: "", consonant: "", vowelfirst: false }
            }

            if (current_group.vowel != "") current_group.vowelfirst = true

            current_group.consonant = word_phonem.at(index) || ""
        }
    }
    output.push(current_group)

    return output;
}

export default function TunicIdeogram(input: TunicIdeogram) {

    let words = input.transcript.split(" ")

    // lista di parole
    // ogni parola è una lista di fonemi
    let words_list_phones = words.map(word => RiTa.phones(word).split("-"))

    // lista di parole
    // ogni parola è un gruppo di vocale e consonante per creare il glifo
    let groups = words_list_phones.map(phones_to_group)


    return <div>
        <div>Transcripted text: {input.transcript}</div>
        <div>Phonemes: {RiTa.phones(input.transcript)}</div>
        <div style={{backgroundColor: input.config.backgroundColor, padding: "5px"}}>
            {
                groups.map((word, index) => 
                    <span style={{ paddingRight: "1rem" }} key={index + "_" + word.join("_")}>
                        <Gliph phonems={word} config={input.config} />
                    </span>
                )
            }
        </div>
    </div>
}